module.exports = __webpack_public_path__ + "img/logo-black.cee5e37b.png";